import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react';
import { reduxHistory, store } from 'common';
import { msalInstance } from 'common/src/api/services/axios-instance';
import { ConnectedRouter } from 'connected-react-router';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import Analytics from './Analytics';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UnauthenticatedAppRouting } from './routing/AppRouting';

const container = document.getElementById('root') as HTMLElement;

const root = createRoot(container);

root.render(
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <AuthenticatedTemplate>
        <ConnectedRouter history={reduxHistory}>
          <Analytics />
          <App />
        </ConnectedRouter>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <ConnectedRouter history={reduxHistory}>
          <UnauthenticatedAppRouting />
        </ConnectedRouter>
      </UnauthenticatedTemplate>
    </Provider>
  </MsalProvider>
);

reportWebVitals();
